export const HeadlineText = ({
  text,
  accent,
  breakAfter,
}: {
  text: string
  accent?: string
  breakAfter?: string
}) => {
  if (breakAfter && text.startsWith(breakAfter)) {
    return (
      <>
        <span className="headline-beat">
          <HeadlineText text={breakAfter} accent={accent} />
        </span>{" "}
        <span className="headline-beat">
          <HeadlineText text={text.slice(breakAfter.length).trimStart()} accent={accent} />
        </span>
      </>
    )
  }
  const start = accent ? text.indexOf(accent) : -1
  if (!accent || start < 0) return <>{text}</>

  return (
    <>
      {text.slice(0, start)}
      <span className="home-emphasis home-highlight">{accent}</span>
      {text.slice(start + accent.length)}
    </>
  )
}
